(function () {
  'use strict';

  var SELECTORS = {
    form: '[data-srv-quick-add-form]',
    quantityButton: '[data-srv-quantity-action]',
    quantityInput: '[data-srv-quantity-input]',
    status: '[data-srv-quick-add-status]',
    submit: '[data-srv-quick-add-submit]',
    reveal: '.srv-reveal'
  };

  function closest(element, selector) {
    if (!element) return null;
    if (element.closest) return element.closest(selector);

    while (element) {
      if (element.matches && element.matches(selector)) return element;
      element = element.parentElement;
    }

    return null;
  }

  function normalizeQuantity(input, nextValue) {
    var minimum = parseInt(input.getAttribute('min'), 10) || 1;
    var maximum = parseInt(input.getAttribute('max'), 10);
    var quantity = parseInt(nextValue, 10);

    if (isNaN(quantity)) quantity = minimum;
    quantity = Math.max(minimum, quantity);
    if (!isNaN(maximum)) quantity = Math.min(maximum, quantity);

    input.value = quantity;
    return quantity;
  }

  function handleQuantityClick(event) {
    var button = closest(event.target, SELECTORS.quantityButton);
    if (!button) return;

    var container = closest(button, '[data-srv-quantity]');
    var input = container && container.querySelector(SELECTORS.quantityInput);
    if (!input) return;

    event.preventDefault();
    var current = parseInt(input.value, 10) || 1;
    var direction = button.getAttribute('data-srv-quantity-action');
    normalizeQuantity(input, direction === 'increase' ? current + 1 : current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setStatus(form, message, state) {
    var status = form.querySelector(SELECTORS.status);
    if (!status) return;

    status.classList.remove('srv-quick-add__status--success', 'srv-quick-add__status--error');
    if (state) status.classList.add('srv-quick-add__status--' + state);
    status.innerHTML = message;
  }

  function setLoading(form, isLoading) {
    var button = form.querySelector(SELECTORS.submit);
    if (!button) return;

    var label = button.querySelector('[data-srv-quick-add-label]');
    var loadingLabel = button.getAttribute('data-loading-label') || 'Adding…';
    var defaultLabel = button.getAttribute('data-default-label') || 'Add to cart';

    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    if (label) label.textContent = isLoading ? loadingLabel : defaultLabel;
  }

  function updateCartCount() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart could not be refreshed.');
        return response.json();
      })
      .then(function (cart) {
        var countElements = document.querySelectorAll('[data-cart-count]');
        var bubbleElements = document.querySelectorAll('[data-cart-count-bubble]');

        Array.prototype.forEach.call(countElements, function (element) {
          element.textContent = cart.item_count;
        });

        Array.prototype.forEach.call(bubbleElements, function (element) {
          if (cart.item_count > 0) {
            element.classList.remove('hide');
          } else {
            element.classList.add('hide');
          }
        });

        try {
          document.dispatchEvent(new CustomEvent('srv:cart:updated', { detail: cart }));
        } catch (error) {
          // CustomEvent is a progressive enhancement only.
        }

        return cart;
      });
  }

  function parseError(response) {
    return response
      .json()
      .then(function (body) {
        var message = body.description || body.message || 'This item could not be added.';
        throw new Error(message);
      })
      .catch(function (error) {
        if (error && error.message) throw error;
        throw new Error('This item could not be added.');
      });
  }

  function handleQuickAdd(event) {
    var form = closest(event.target, SELECTORS.form);
    if (!form || !window.fetch || !window.FormData) return;

    event.preventDefault();
    setLoading(form, true);
    setStatus(form, '', '');

    var action = form.getAttribute('action') || '/cart/add';
    if (action.indexOf('.js') === -1) action = action.replace(/\/$/, '') + '.js';

    fetch(action, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) return parseError(response);
        return response.json();
      })
      .then(function () {
        return updateCartCount();
      })
      .then(function () {
        setStatus(form, 'Added. <a href="/cart">View cart</a>', 'success');
      })
      .catch(function (error) {
        setStatus(form, error.message || 'This item could not be added.', 'error');
      })
      .then(function () {
        setLoading(form, false);
      });
  }

  function initializeRevealMotion(scope) {
    var root = scope || document;
    var items = root.querySelectorAll(SELECTORS.reveal);
    if (!items.length) return;

    if (document.body.getAttribute('data-srv-reveal') !== 'true' || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (item) {
        item.classList.add('srv-reveal--visible');
      });
      return;
    }

    document.body.classList.add('srv-motion-enabled');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('srv-reveal--visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    Array.prototype.forEach.call(items, function (item) {
      observer.observe(item);
    });
  }

  document.addEventListener('click', handleQuantityClick);
  document.addEventListener('submit', handleQuickAdd);
  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches(SELECTORS.quantityInput)) {
      normalizeQuantity(event.target, event.target.value);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeRevealMotion(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeRevealMotion(document);
    });
  } else {
    initializeRevealMotion(document);
  }
})();
